@if (!isBluefinTokenRetry) {
  <h1>Proceed to Citrix Payment Application</h1>
  <p>The payment advice number will be required to complete a manual payment in the Citrix application.</p>
  <b>Copy the payment advice number to continue:</b>
  <div class="pan">
    <span>{{ cargoPaymentInfo?.paymentAdviceNumber }}</span>
    <button
      class="copyLogo"
      (click)="copyPaymentAdviceNumber()"
      [ngClass]="isManualPaymentContinueDisabled ? 'copyLogo copy' : 'copyLogo copied'"
    >
      @if (isManualPaymentContinueDisabled) {
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5263 0H1.78947C0.805263 0 0 0.818182 0 1.81818V14.5455H1.78947V1.81818H12.5263V0ZM15.2105 3.63636H5.36842C4.38421 3.63636 3.57895 4.45455 3.57895 5.45455V18.1818C3.57895 19.1818 4.38421 20 5.36842 20H15.2105C16.1947 20 17 19.1818 17 18.1818V5.45455C17 4.45455 16.1947 3.63636 15.2105 3.63636ZM15.2105 18.1818H5.36842V5.45455H15.2105V18.1818Z"
            fill="#0074C8"
          />
        </svg>
      } @else {
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5ZM8.47644 11.9158L13.4471 6.49321C13.727 6.18787 14.2015 6.16724 14.5068 6.44713C14.7844 6.70158 14.8267 7.1168 14.6218 7.4196L14.5529 7.50679L9.05287 13.5068C8.79056 13.7929 8.3595 13.8278 8.05645 13.6049L7.96967 13.5303L5.46967 11.0303C5.17678 10.7374 5.17678 10.2626 5.46967 9.96967C5.73594 9.7034 6.1526 9.6792 6.44621 9.89705L6.53033 9.96967L8.47644 11.9158L13.4471 6.49321L8.47644 11.9158Z"
            fill="#068A1E"
          />
        </svg>
      }
      <span>{{ isManualPaymentContinueDisabled ? 'Copy' : 'Copied' }}</span>
    </button>
  </div>
  <alaska-button class="button cancel" secondary style="float: left" (click)="close()">Cancel</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
  <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click --><alaska-button
    [disabled]="isManualPaymentContinueDisabled"
    class="button continue"
    primary
    style="float: right"
    (click)="onCCManualContinue()"
  >
    Continue
  </alaska-button>
} @else {
  <h1>Please try again</h1>
  <p>Something happened while retrieving the payment data from Citrix. Please try again.</p>
  <alaska-button class="button cancel" secondary style="float: left" (click)="close()">Cancel</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
  <alaska-button class="button continue" primary style="float: right" (click)="onRetryToken()">Try Again</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
}
